import { SEARCH_PARAM_UNIT_ID } from 'routes/(common_search_params)/-searchParams'
import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { SEARCH_PARAM_JOB_ID } from 'routes/job/-searchParams'
import { createValueStorySearch } from 'routes/value-stories/-searchParams'
import {
  GeckoEntry,
  GeckoKestrelModel,
  KestrelInspectionType,
  RolodexEntryType,
} from 'types'

export interface SearchResultNavigation {
  to: string
  params?: Record<string, string>
  search?: Record<string, string | undefined>
}

export function getSearchResultUrl(
  entry: GeckoEntry,
  siteID: string
): SearchResultNavigation | null {
  switch (entry.type) {
    case RolodexEntryType.UNIT:
      return {
        to: '/assets/routing',
        search: {
          view: 'details',
          [SEARCH_PARAM_SITE_ID]: siteID,
          [SEARCH_PARAM_UNIT_ID]: entry.id,
        },
      }
    // TODO: We need to add system to url params
    case RolodexEntryType.SYSTEM:
      return {
        to: '/system-lens',
        search: {
          [SEARCH_PARAM_SITE_ID]: siteID,
        },
      }
    case RolodexEntryType.JOB:
      return {
        to: '/job',
        search: {
          ...(entry.tags.organization
            ? { [SEARCH_PARAM_ORG_ID]: entry.tags.organization }
            : {}),
          [SEARCH_PARAM_SITE_ID]: siteID,
          [SEARCH_PARAM_JOB_ID]: entry.id,
        },
      }
    case RolodexEntryType.ASSET_MODEL:
      return {
        to: '/assets/routing',
        search: {
          view: 'components',
          [SEARCH_PARAM_SITE_ID]: siteID,
          [SEARCH_PARAM_UNIT_ID]: entry.tags.unit!,
        },
      }
    case RolodexEntryType.INSPECTION:
      return {
        to: '/assets/routing',
        search: {
          view: 'inspections',
          [SEARCH_PARAM_SITE_ID]: siteID,
          [SEARCH_PARAM_UNIT_ID]: entry.tags.unit!,
        },
      }
    case RolodexEntryType.VALUE_STORY:
      return {
        to: '/value-stories/details',
        search: createValueStorySearch({
          orgId: entry.tags.organization ?? undefined,
          siteId: siteID,
          valueStoryId: entry.id,
        }),
      }
    case RolodexEntryType.KESTREL_MODEL: {
      const entryAsKestrelModel = entry as GeckoKestrelModel

      const redirectDestination =
        entryAsKestrelModel.data.inspection_type ===
          KestrelInspectionType.SITEVIEW && !!entryAsKestrelModel.tags.unit
          ? `systemview/${entryAsKestrelModel.tags.unit}`
          : `kestrel/${entryAsKestrelModel.id}`

      return {
        to: `/${redirectDestination}`,
        search: {
          [SEARCH_PARAM_SITE_ID]: entryAsKestrelModel.tags.site ?? undefined,
          [SEARCH_PARAM_ORG_ID]:
            entryAsKestrelModel.tags.organization ?? undefined,
        },
      }
    }
    default:
      return null
  }
}
